__turbopack_context__.v({
  "cartBadge": "CartBadge-module-scss-module__DeN4uG__cartBadge",
  "cartBadgeText": "CartBadge-module-scss-module__DeN4uG__cartBadgeText",
});
